import icSettings from 'assets/svg/ic_settings.svg';
import icDocument from 'assets/svg/ic_document.svg';
import icInventory from 'assets/svg/ic_inventory.svg';
import icWallet from 'assets/svg/ic_wallet.svg';
import icMetamask from 'assets/img/ic_metamask.png';
import icThetanWallet from 'assets/img/ic_thetan_wallet.png';
import icCoinbase from 'assets/svg/ic_coinbase.svg';
import icWalletConnect from 'assets/svg/ic_wallet_connect.svg';
import icSequence from 'assets/img/ic_sequence_wallet.png';
import icIngame from 'assets/svg/ic_ingame.svg';
import { logout } from '@profile/src/redux/remoteActions';
import { MenuItem, navigateToHome, navigateToInGamePage, navigateToProfile } from 'src/utils/navigate';
import { WalletProvider } from 'src/utils/types';
import { InGameCategoryKey } from 'src/utils/types';
export const menuList = [{
  key: MenuItem.INVENTORY,
  name: 'Inventory',
  icon: icInventory,
  handlePress: () => navigateToProfile(MenuItem.INVENTORY)
}, {
  key: MenuItem.ACCOUNT_SETTINGS,
  name: 'Account Setting',
  icon: icSettings,
  handlePress: () => navigateToProfile(MenuItem.ACCOUNT_SETTINGS)
}, {
  key: MenuItem.WALLET,
  name: 'Wallet',
  icon: icWallet,
  handlePress: () => navigateToProfile(MenuItem.WALLET)
}, {
  key: MenuItem.IN_GAME,
  name: 'Ingame',
  icon: icIngame,
  children: [{
    key: InGameCategoryKey.BattleRewards,
    name: 'Battle Rewards',
    handlePress: () => navigateToInGamePage({
      urlSearch: '',
      category: InGameCategoryKey.BattleRewards
    })
  }]
}, {
  key: MenuItem.HISTORY,
  name: 'History',
  icon: icDocument,
  handlePress: () => navigateToProfile(MenuItem.HISTORY)
}, {
  key: MenuItem.LOGOUT,
  name: 'Logout',
  handlePress: ({
    dispatch
  }) => {
    dispatch(logout());
    navigateToHome();
  }
}];
export const walletProviderMap = {
  [WalletProvider.COINBASE]: icCoinbase,
  [WalletProvider.METAMASK]: icMetamask,
  [WalletProvider.WALLET_CONNECT]: icWalletConnect,
  [WalletProvider.SEQUENCE]: icSequence,
  [WalletProvider.THETAN_WALLET]: icThetanWallet
};